module.exports = __webpack_public_path__ + "static/media/inventory_icon.3b7b753d.svg";